import watch from 'redux-watch'

import { AppStore } from 'src/client/store'
import { PATH_CHANGE } from 'actions/actionConstants'

export function watchNavigation(store: AppStore) {
  store.subscribe(
    watch(store.getState, 'router.location.pathname')(() => {
      store.dispatch({ type: PATH_CHANGE })
    }),
  )
}
